import { palette } from './theme/palette';
import { theme } from './theme/theme';

export const BrandConfig = {
  palette: palette,
  theme: theme,
};
